import { ItemDetailCard } from '../../projectData'

/**
 * BankTransferDetail component
 * Displays details of a bank transfer transaction for redemption, including order info, reference ID, settlement date, and bank details.
 */
export const BankTransferDetail = ({ data }) => {
    return (
        <div className='mt-4'>
            <div className='col-sm-12 mt-4'>
                <div className="card  p-2" style={{ border: '1px solid #eaeaea', backgroundColor: "#EFEFEF" }}>
                    <div className="d-flex justify-content-between  p-2 ">
                        <div className="fw-semibold fs-6">Redemption Id: <span className='fw-semibold'>{data?.order_id}</span></div>
                        <div className="fw-semibold fs-6">Date:<span className='fw-semibold'> {data?.order_date}</span> </div>
                    </div>
                    <>
                        <ItemDetailCard data={data} />
                    </>
                </div>
            </div>

            <div style={{ border: '1px solid #eaeaea' }} className='card mt-4'>
                <div className="card-header px-6 py-3" style={{ minHeight: '39px', backgroundColor: '#474747' }}>
                    <div className="d-flex justify-content-between  w-100">
                        <div className="text-white  fw-semibold">
                            <div className='fw-semibold'>Reference Id</div>
                            <div>{data?.bank_transction_ref ? data?.bank_transction_ref : '--'}</div>
                        </div>
                        <div className="text-white text-end fw-semibold">
                            <div className='fw-semibold'> Date of Transfer </div>
                            <div> {data?.settlement_date ? data?.settlement_date : '--'}  </div>
                        </div>
                    </div>

                </div>
                <div className="card-body p-4 border-top">
                    <div className='d-flex flex-column'>
                        <div className=' '>Name : <span className='fw-semibold'>{data?.nameAtBank ? data?.nameAtBank : '---'}</span></div>
                        <div className=''>Account No. : <span className='fw-semibold'>{data?.bank_account ? data?.bank_account : '---'}</span></div>
                        <div className=''>Bank Name : <span className='fw-semibold'>{data?.api_bankName ? data?.api_bankName : '---'}</span></div>
                        <div className=''>IFSC Code : <span className='fw-semibold text-captilize'>{data?.ifsc_code ? data?.ifsc_code : '---'}</span></div>
                    </div>
                    {/* <div className='p-4 fs-5 fw-semibolder text-center'>
                        Amount :- Rs 342894/-
                    </div> */}

                </div>
            </div>
        </div>
    )
}
